define("shared/utils/number-helpers/precise-round", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f

  /**
   * Converts a number into a formatted string
   * with the given number of significant digits.
   *
   * @method preciseRound
   * @param {Number} value Numerical value
   * @param {Number} significantDigits Number of significant digits to round to
   *
   * @return {String} Formatted string, at the precison level provided
   */
  const preciseRound = (value, significantDigits) => {
    if (!(0, _utils.isPresent)(value) || typeof value === 'string' || typeof value === 'object') {
      return 'NaN';
    }

    if (value.toFixed().length > significantDigits) {
      return Number.parseFloat(value).toFixed();
    }

    return Number.parseFloat(value).toPrecision(significantDigits);
  };

  var _default = preciseRound;
  _exports.default = _default;
});